import { AppBundle } from 'api/optimalprint-sdk.d';

const getDesignsFromFamilies = (
  families: AppBundle.Api.Response.Category.V3.CategoryDesignsListV3Response.IFamily[],
) => {
  const designs: AppBundle.Api.Response.Category.V3.CategoryDesignsListV3Response.Family.IDesign[] = [];
  families.forEach((family) => {
    if (family.designs) {
      designs.push(...family.designs);
    }
  });
  return designs;
};

export default getDesignsFromFamilies;
